import { apiFetch } from './apiClient';

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const iso = value => typeof value === 'string' && Number.isFinite(Date.parse(value)) && new Date(value).toISOString() === value;
const invalid = () => { throw new Error('Risposta dei riferimenti non valida. Nessun file esportato.'); };

function timestamp(value) {
  // Postgres returns UTC offsets and up to six fractional digits, unlike JS
  // toISOString(). Keep the provider value (including microseconds) in exports.
  const match = typeof value === 'string' && value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?(?:Z|\+00:00)$/);
  if (!match || !Number.isFinite(Date.parse(value))
    || new Date(value).toISOString() !== `${match[1]}.${(match[2] || '').padEnd(3, '0').slice(0, 3)}Z`) invalid();
  return value;
}

export function retentionCutoff(day) {
  const value = `${day}T23:59:59.999Z`;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || !iso(value)) throw new Error('Scegli una data valida.');
  return value;
}

function optionalUuid(value) {
  if (value === null || value === undefined) return null;
  if (typeof value !== 'string' || !uuid.test(value)) invalid();
  return value;
}

export function sanitizeRetentionPage(payload, kind, before) {
  if (!payload || payload.kind !== kind || payload.before !== before || !iso(payload.generated_at)
    || !Array.isArray(payload.entries) || payload.entries.length > 100 || typeof payload.has_more !== 'boolean') invalid();
  const ids = new Set();
  const entries = payload.entries.map(row => {
    if (!row || typeof row.id !== 'string' || !uuid.test(row.id) || ids.has(row.id)
      || row.reference !== `NS-${kind === 'contact' ? 'C' : 'A'}-${row.id}`
      || Date.parse(timestamp(row.expires_at)) > Date.parse(before)) invalid();
    ids.add(row.id);
    // Explicit allowlist: names, email addresses, bodies, notes and slots must
    // never enter the downloadable file, even if the server adds fields later.
    const entry = { id: row.id, reference: row.reference, created_at: timestamp(row.created_at), expires_at: row.expires_at,
      notification_email_id: optionalUuid(row.notification_email_id) };
    if (kind === 'contact') {
      entry.last_interaction_at = timestamp(row.last_interaction_at);
    } else {
      if (row.calendar_event_id != null && (typeof row.calendar_event_id !== 'string' || row.calendar_event_id.length > 512)) invalid();
      entry.calendar_event_id = row.calendar_event_id ?? null;
      entry.confirmation_email_id = optionalUuid(row.confirmation_email_id);
    }
    return entry;
  });
  const next = payload.has_more ? payload.next_cursor : null;
  if (payload.has_more && (!entries.length || !uuid.test(next || '') || next !== entries.at(-1).id)) invalid();
  return { schema_version: 1, kind, before, generated_at: payload.generated_at, entries,
    has_more: payload.has_more, next_cursor: next, non_atomic: true,
    warning: 'Solo riferimenti: non autorizza cancellazioni. ID Resend diversi dagli ID della casella. Verificare le copie prima del purge; conservare il file ad accesso ristretto, fuori da Git.' };
}

export async function loadRetentionPage({ kind, day, after = null, signal }) {
  if (!['contact', 'appointment'].includes(kind)) throw new Error('Tipo di archivio non valido.');
  const before = retentionCutoff(day);
  if (after !== null && !uuid.test(after)) throw new Error('Cursore non valido.');
  const params = new URLSearchParams({ kind, before });
  if (after) params.set('after', after);
  const result = await apiFetch(`/api/admin/retention-references?${params}`, { method: 'GET', cache: 'no-store', signal });
  if (!result.ok) throw new Error([401, 403].includes(result.status)
    ? 'È richiesto un accesso admin con MFA. Accedi nuovamente e riprova.'
    : 'Impossibile leggere i riferimenti. Nessun file esportato.');
  return sanitizeRetentionPage(await result.json(), kind, before);
}
